import { render, staticRenderFns } from "./CommandeEdit.vue?vue&type=template&id=2bedd622&"
import script from "./CommandeEdit.vue?vue&type=script&lang=js&"
export * from "./CommandeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bedd622')) {
      api.createRecord('2bedd622', component.options)
    } else {
      api.reload('2bedd622', component.options)
    }
    module.hot.accept("./CommandeEdit.vue?vue&type=template&id=2bedd622&", function () {
      api.rerender('2bedd622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/commandes/CommandeEdit.vue"
export default component.exports